const EVENTS = {
  APPLICATION_IS_WORKING: 'applicationIsWorking',
  APPLICATION_WORK_FINISHED: 'applicationWorkFinished',
  APP_READY: 'appReady',
  TOAST_NOTIFICATION_REQUESTED: 'toastNotificationRequested',
  USER_DATA_AVAILABLE: 'userDataAvailable',
  RESTAURANT_DATA_AVAILABLE: 'restaurantDataAvailable',
  USER_CONNECTED: 'userConnected',
  LOGOUT_REQUESTED: 'logoutRequested',
  USER_DISCONNECTED: 'userDisconnectored',

  // Events related to orders
  ORDER_CREATED: 'order:created',
  ORDER_UPDATED: 'order:updated',
  ORDER_PICKUP_MARKED: 'order:pickup:marked',
  ORDER_REVIEW_SUBMITTED: 'order:review:submitted',
  ORDER_CANCELLED: 'order:cancelled',
  ORDER_STATUS_UPDATED: 'order:status:updated',
}

export { EVENTS }
